import logUtil from 'utils/log'
import React from 'react'
import B from 'components/B'
import TextGreen from 'components/TextGreen'
import getPriceOrFreeLabelStringUtil from 'utils/string/get-price-or-free-label'

/**
 * @param props
 * @param props.price
 * @param props.discountPrice
 * @return {JSX.Element}
 * @constructor
 */
export default function PriceAndDiscountPrice (props) {
  const {
    price,
    discountPrice,
    showStrikethroughPricing = false,
    compareAtPrice,
    rawPrice
  } = props

  logUtil('PriceAndDiscountPrice').debug('props=', props)

  let priceLabel

  if (showStrikethroughPricing) {
    return <><s>{getPriceOrFreeLabelStringUtil(compareAtPrice)}</s><B><TextGreen>  {getPriceOrFreeLabelStringUtil(rawPrice)}</TextGreen></B></>
  }

  if (price) {
    priceLabel = getPriceOrFreeLabelStringUtil(price)
  }

  if (priceLabel && discountPrice == null) {
    return <>{priceLabel}</>
  }

  if (!price && !discountPrice) {
    return <>FREE</>
  }

  return <><s>{priceLabel}</s><B><TextGreen>  {getPriceOrFreeLabelStringUtil(discountPrice)}</TextGreen></B></>
}
